export default function SubCampaignModel(dict) {
    this.campaignId = dict.campaignId;
    this.name = dict.name;
    this.points = dict.points;
    this.price = dict.price;
    this.originalPrice = dict.originalPrice;
    this.discount = dict.discount;
    this.quantity = dict.quantity;
    this.type = dict.type;
    this.value = dict.value;
    this.qty = this.quantity - dict.itemCountSold;

    this.listSubItem = [];
    if (dict.subitems && dict.subitems instanceof Array) {
        for (var i = 0; i < dict.subitems.length; i++) {
            var itemSub = dict.subitems[i];
            this.listSubItem.push(new SubCampaignModel(itemSub));
        }
    }
}
